'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _MinusOutlined = _interopRequireDefault(require('./lib/icons/MinusOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _MinusOutlined;
  exports.default = _default;
  module.exports = _default;